import { AxiosClient, AxiosToken } from '../config/axios'

/**
 * This method is used to connect with backend and get list of templates
 * @return {Array} templates
*/
export const getTemplates = async (): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get('/template/list')
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of active templates
 * @return {Array} active templates
*/
export const getTemplatesActive = async (): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get('/template/list-active')
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of templates types
 * @return {Array} templates types
*/
export const getTemplatesType = async (): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get('/template/list-types')
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of templates by type
 * @param {Number} type id
 * @return {Array} templates documents type
*/
export const getTemplateDocumentsType = async (type:number): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get(`/template/list-documents-type?type=${type}`)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

export const getTemplatesCompany = async (): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get('/template/list-company')
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get template by id
 * @param {String} id
 * @return {ITemplate} ITemplate
*/
export const getTemplate = async (id: string): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get(`/template?id=${id}`)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and save template
 * @param {Object} data
 * @return {Object} message and data: template
*/
export const saveTemplate = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.post('/template', data)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and update template
 * @param {Object} data
 * @return {Object} message and data: template
*/
export const updateTemplate = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.put('/template', data)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and delete template
 * @param {Object} data
 * @return {String} message
*/
export const deleteTemplate = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.delete('/template', {data})
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}